import React from "react";
import { Roadmap, Navbar } from "../components";

const RoadmapPage = () => {
  return (
    <div>
      <div className="gradient-bg-welcome">
        <Navbar />
        <Roadmap />
      </div>
    </div>
  );
};

export default RoadmapPage;
